import { LucideListOrdered } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import { TrackingHistoryWeb } from "./web";
import { TrackingHistoryWebEditor } from "./web-editor";

export default registerBlock({
  type: "tracking-history",
  name: "editorBlocksLibrary.blocks.tracking-history.title",
  description: "editorBlocksLibrary.blocks.tracking-history.description",
  Icon: LucideListOrdered,
  category: BlockCategory.TRACKING,
  hasDynamicContent: true,
  components: {
    // email: {
    //   component: TrackingHistoryEmail,
    //   editor: { component: TrackingHistoryEmailEditor },
    // },
    web: {
      component: TrackingHistoryWeb,
      editor: { component: TrackingHistoryWebEditor },
    },
  },
});
